// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"a56ee3dd","549":"bf05b2af","787":"f0db260c"}[chunkId] + ".chunk.js";
};